"use client"

import { useEffect, useState } from "react"
import axios from "axios"
import { FaTrash, FaBan, FaCheck, FaChevronLeft, FaChevronRight, FaUser } from "react-icons/fa"
import "../styles/Clientes.css"

const Clientes = () => {
  const [clientes, setClientes] = useState([])
  const [busca, setBusca] = useState("")
  const [paginaAtual, setPaginaAtual] = useState(1)
  const [loading, setLoading] = useState(true)
  const clientesPorPagina = 10
  const [searchCpf, setSearchCpf] = useState('');

  // Função auxiliar para formatar o CPF enquanto o usuário digita
  const formatarCPF = (valor) => {
    return valor
      .replace(/\D/g, '') 
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d{1,2})/, '$1-$2')
      .replace(/(-\d{2})\d+?$/, '$1'); 
  };

  useEffect(() => {
    buscarClientes()
  }, [])

  const buscarClientes = async () => {
    try {
      setLoading(true)
      const token = localStorage.getItem("token")
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/admin/clientes`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      setClientes(res.data)
      setLoading(false)
    } catch (err) {
      console.error("Erro ao buscar clientes", err)
      setLoading(false)
    }
  }

  const deletarCliente = async (id) => {
    if (window.confirm("Tem certeza que deseja deletar este cliente?")) {
      try {
        const token = localStorage.getItem("token")
        await axios.delete(`${process.env.REACT_APP_API_URL}/admin/clientes/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        alert("Cliente deletado com sucesso!")
        buscarClientes()
      } catch (err) {
        alert("Erro ao deletar cliente!")
      }
    }
  }

  const bloquearCliente = async (id) => {
    try {
      const token = localStorage.getItem("token")
      await axios.put(
        `${process.env.REACT_APP_API_URL}/admin/clientes/bloquear/${id}`,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      )
      alert("Status do cliente atualizado com sucesso!")
      buscarClientes()
    } catch (err) {
      alert("Erro ao bloquear/desbloquear cliente!")
    }
  }

  const clientesFiltrados = clientes.filter((c) => {
    // Filtro por Nome ou Email
    const matchBusca = 
      c.nomeCompleto?.toLowerCase().includes(busca.toLowerCase()) ||
      c.email?.toLowerCase().includes(busca.toLowerCase());

    // Filtro por CPF (removendo a pontuação para comparar com segurança)
    const cpfBuscadoLimpo = searchCpf.replace(/\D/g, '');
    const cpfClienteLimpo = c.cpf ? c.cpf.replace(/\D/g, '') : '';
    const matchCpf = cpfClienteLimpo.includes(cpfBuscadoLimpo);

    return matchBusca && matchCpf;
  })

  const indiceUltimo = paginaAtual * clientesPorPagina
  const indicePrimeiro = indiceUltimo - clientesPorPagina
  const clientesPaginados = clientesFiltrados.slice(indicePrimeiro, indiceUltimo)
  const totalPaginas = Math.ceil(clientesFiltrados.length / clientesPorPagina)

  return (
    <div className="container-clientes">
      <h2>
        <FaUser /> Gerenciamento de Clientes
      </h2>

      <div className="clientes-controls" style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
        <input
          type="text"
          placeholder="Buscar por nome ou email..."
          value={busca}
          onChange={(e) => setBusca(e.target.value)}
          style={{ flex: 1 }}
        />
        {/* NOVO CAMPO: Busca por CPF */}
        <input
          type="text"
          placeholder="Buscar por CPF..."
          value={searchCpf}
          onChange={(e) => setSearchCpf(formatarCPF(e.target.value))}
          maxLength={14}
          style={{ flex: 1 }}
        />
      </div>

      {loading ? (
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>Carregando clientes...</p>
        </div>
      ) : clientesFiltrados.length === 0 ? (
        <div className="empty-state">
          <p>Nenhum cliente encontrado.</p>
        </div>
      ) : (
        <div className="table-container">
          <table className="tabela-clientes">
            <thead>
              <tr>
                <th>Nome Completo</th>
                <th>Email</th>
                <th>CPF</th>
                <th>WhatsApp</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              {clientesPaginados.map((cliente) => (
                <tr key={cliente._id}>
                  <td>{cliente.nomeCompleto || "N/A"}</td>
                  <td>{cliente.email || "N/A"}</td>
                  <td>{cliente.cpf || "N/A"}</td>
                  <td>{cliente.whatsapp || "N/A"}</td>
                  <td className="acoes-cell">
                    <button
                      onClick={() => deletarCliente(cliente._id)}
                      className="btn-action btn-delete"
                      title="Excluir cliente"
                    >
                      <FaTrash />
                    </button>
                    <button
                      onClick={() => bloquearCliente(cliente._id)}
                      className={cliente.tipo === "bloqueado" ? "btn-action btn-unblock" : "btn-action btn-block"}
                      title={cliente.tipo === "bloqueado" ? "Desbloquear cliente" : "Bloquear cliente"}
                    >
                      {cliente.tipo === "bloqueado" ? <FaCheck /> : <FaBan />}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {!loading && clientesFiltrados.length > 0 && (
        <div className="paginacao-clientes">
          <button onClick={() => setPaginaAtual((prev) => Math.max(prev - 1, 1))} disabled={paginaAtual === 1}>
            <FaChevronLeft /> Anterior
          </button>
          <span>
            Página {paginaAtual} de {totalPaginas}
          </span>
          <button
            onClick={() => setPaginaAtual((prev) => Math.min(prev + 1, totalPaginas))}
            disabled={paginaAtual === totalPaginas}
          >
            Próximo <FaChevronRight />
          </button>
        </div>
      )}
    </div>
  )
}

export default Clientes